import { render } from "./DropDownListPatEstadoConservacao.vue?vue&type=template&id=155d07f2&ts=true"
import script from "./DropDownListPatEstadoConservacao.vue?vue&type=script&lang=ts"
export * from "./DropDownListPatEstadoConservacao.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__